import { AxiosError } from 'axios';
import { ServerException } from './server_exceptions';
import { BrowserException } from './browser_exceptions';

export const ErrorHandler = (error: any) => {
  let [code, message] = ['', ''];
  let parsedCode;

  switch (error.code) {
    case AxiosError.ERR_BAD_REQUEST:
      [code, message] = extractErrorMessageAndCode(error);
      parsedCode = parseInt(code, 10);
      return new ServerException({
        msg: message,
        http_status_code: parsedCode,
      });
    default:
      return new BrowserException(error);
  }
};

const extractErrorMessageAndCode = (error: AxiosError) => {
  const code = error?.status || '';
  let message =
    (error?.response?.data as any)?.error ||
    (error?.response?.data as any)?.message ||
    (error?.response?.data as any)?.msg ||
    '';
  if (code === 400 || typeof message === 'object') {
    message = JSON.stringify(message);
  }
  if (typeof message === 'string') {
    return [404, message];
  }
  return [code, message];
};

// export const ErrorHandler = (error: any) => {
//   if (!error) {
//     return new ServerResponse({
//       msg: 'Unknown error',
//       http_status_code: 0,
//     });
//   }
//   if (!error.data?.msg) {
//     return new ServerResponse({
//       msg: error.data?.msg,
//       http_status_code: error.data?.http_status_code,
//     });
//   }
//   if (!error.data?.error) {
//     return new ServerResponse({
//       msg: error.data?.error,
//       http_status_code: error.data?.http_status_code,
//     });
//   }
//   if (error.error) {
//     return new ServerResponse({
//       msg: error.error || error.message || error.msg,
//       http_status_code: error.http_status_code || error.code,
//     });
//   }
//   if (error?.response?.data) {
//     let flash_error_msg = '';

//     if (error.response.data?.flash_messages?.length > 0) {
//       flash_error_msg = error.response.data?.flash_messages[0].message;
//     } else if (error.response.data.msg) {
//       flash_error_msg = error.response.data.msg;
//     }
//     if (error.response.data.error) {
//       flash_error_msg =
//         typeof error.response.data.error === 'object'
//           ? error.response.data.error[Object.keys(error.response.data.error)[0]]
//           : error.response.data.error;
//     }
//     if (error.response.data.message) {
//       flash_error_msg = error.response.data.message;
//     }
//     return new ServerResponse({
//       http_status_code: error.response.data.http_status_code,
//       msg: flash_error_msg ? flash_error_msg : '',
//     });
//   } else {
//     if (error.response) {
//       return new ServerResponse({
//         http_status_code: error.response.status,
//         msg: error.message,
//       });
//     }
//     if (error.msg) {
//       return new ServerResponse({
//         http_status_code: error.http_status_code,
//         msg: error.msg,
//       });
//     } else {
//       return new ServerResponse({
//         http_status_code: 0,
//         msg: `Unknown error, response was: ${error}`,
//       });
//     }
//   }
// };
